import React from "react";
import { formatTime } from "../../../utils/dateutils";

const NotificationSlots = ({ frequency, onSlotClick, selectedSlotIds = [] }) => {

    const frequencyData = JSON.parse(frequency || "[]");
    const slotData = frequencyData?.[0];

    if (!slotData?.slots) {
        return null;
    }

    const handleSlotClick = (slot) => {
        if (slot.assignedVolunteer) return; // Don't allow clicking assigned slot
        // Call parent callback if provided
        if (onSlotClick) {
            onSlotClick(slot);
        }
    };

    return (
        <div>
            <div className="notification-slots-grid">
                {slotData.slots.map((slot) => {
                    const start = formatTime(slot.startTimeTimestamp, slot.startTime);
                    const end = formatTime(slot.endTimeTimestamp, slot.endTime);
                    const timeRange = start && end ? `${start} - ${end}` : null;
                    const isSelected = selectedSlotIds.includes(slot.id);

                    return (
                        <div
                            key={slot.id}
                            className={`notification-slot-card ${slot.assignedVolunteer ? "assigned" : ""} ${isSelected ? "selected" : ""}`}
                            onClick={() => handleSlotClick(slot)}
                        >
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="notification-slot-number" style={{ fontSize: '10px' }}>Shift {slot.slotNumber}</div>
                                <div className="notification-slot-duration" style={{ fontSize: '9px', color: '#666' }}>
                                    {slot.duration} {slot.duration === 1 ? "hr" : "hrs"}
                                </div>
                            </div>
                            {timeRange && (
                                <div className="notification-slot-time" style={{ fontSize: '9px', fontWeight: '500', marginTop: '2px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {timeRange}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default NotificationSlots;
